import React__default, { useState, useMemo } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function useDisabledOptionState(selectionProps) {
    const state = useState(selectionProps === null || selectionProps === void 0 ? void 0 : selectionProps.disabledKeys);
    const [, setDisabledKeys] = state;
    const [prevDisabledKeys, setPrevDisabledKeys] = useState(selectionProps === null || selectionProps === void 0 ? void 0 : selectionProps.disabledKeys);
    if ((selectionProps === null || selectionProps === void 0 ? void 0 : selectionProps.disabledKeys) !== prevDisabledKeys) {
        setDisabledKeys(selectionProps === null || selectionProps === void 0 ? void 0 : selectionProps.disabledKeys);
        setPrevDisabledKeys(selectionProps === null || selectionProps === void 0 ? void 0 : selectionProps.disabledKeys);
    }
    return state;
}
function useListboxList(listProps, listboxRef, listboxState, setDisabledKeys) {
    return useMemo(()=>({
            listState: listboxState,
            listProps: _object_spread({
                disallowEmptySelection: true,
                shouldFocusOnHover: true,
                shouldSelectOnPressUp: true
            }, listProps),
            listboxRef,
            setDisabledKeys
        }), [
        listboxState,
        listProps,
        listboxRef,
        setDisabledKeys
    ]);
}
const SwanListboxListContext = /*#__PURE__*/ React__default.createContext(undefined);
function useSwanListboxListContext() {
    return useNonNullishContext(SwanListboxListContext);
}

export { SwanListboxListContext, useDisabledOptionState, useListboxList, useSwanListboxListContext };
